import { css } from '@emotion/core';
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize, colors, codeFontFamily } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { SourceCodeLine, SourceCodeText } from '@atlassian/bitkit-code';
import { media } from '@atlassian/bitkit-responsive';

export const Gutter = styled.td`
  background: ${token('elevation.surface', colors.N0)};
  border-right: ${token('color.border', `1px solid ${colors.N40}`)};
  color: ${token('color.text.subtlest', colors.N100)};
  font-family: ${codeFontFamily()};
  min-width: ${gridSize() * 10}px;
  padding: 2px 0;
  text-align: center;
  user-select: none;
  white-space: nowrap;
  width: 1%;
  vertical-align: top;
  ${media.upToMedium(`
    min-width: 0px;

    // && needed to override AK's reset style for td which has padding at 0
    && {
      padding-left: 1em;
      padding-right: 1em;
    }
  `)}
`;

export const hunkPadding = css({
  'tr:first-child > td': {
    paddingTop: '1em',
  },
  'tr:last-child > td': {
    paddingBottom: '1em',
  },
});

export const SearchSourceCodeLine = styled.td`
  ${SourceCodeLine}
`;

export const SearchSourceCodeText = styled.span`
  ${SourceCodeText}
  em {
    font-style: normal;
    color: ${token('color.text.warning.inverse', colors.N700)};
    background: ${token('color.background.warning.bold', colors.Y75)};
  }
`;

export const SubtleLink = styled.a`
  color: inherit;
  display: block;
`;
